import { render, staticRenderFns } from "./SsoCallBack.vue?vue&type=template&id=49108be0"
import script from "./SsoCallBack.vue?vue&type=script&lang=ts"
export * from "./SsoCallBack.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports